module.exports = __webpack_public_path__ + "img/product5.ccb9abd4.jpg";